import React from 'react'
import PropTypes from 'prop-types'

export const StatusReportStatusBadge = ({
  statusInfo
}) => {
  if (!statusInfo) return null
  return (
    <div className='radius-md px-2 relative'>
      <div
        className='absolute top-0 left-0 right-0 bottom-0 radius-md'
        style={{ opacity: 0.35, backgroundColor: statusInfo?.color || 'var(--color-background-light)' }}
      />
      <span className='relative font-size-xs'>
        {statusInfo.displayName}
      </span>
    </div>
  )
}

StatusReportStatusBadge.propTypes = {
  statusInfo: PropTypes.shape({
    displayName: PropTypes.string,
    color: PropTypes.string
  }).isRequired
}
